import cashOrdersList from '../response/cash/cash-orders-list.json';
import cashOrdersListSearchByCard from '../response/cash/cash-orders-list-search-by-card-number.json';
import cashOrderDetails from '../response/cash/cash-order-details.json';
import cashOrderDefaultsPreloaded from '../response/cash/cash-order-defaults-preloaded.json';
import cashOrderDefaultsLoadable from '../response/cash/cash-order-defaults-loadable.json';
import cashOrderCreateResponse from '../response/cash/cash-order-create-response.json';
import cashOrderCardDetails from '../response/cash/cash-order-card-details.json';

export default function CashRoutes() {
  // Get Cash Orders
  this.get('cards-api/v1/ampolcash/:grandParentId/:accountNumber/orders', (schema, request) => {
    const { cardNumber } = request.queryParams;

    return cardNumber === '7076787100003272' ? cashOrdersListSearchByCard : cashOrdersList;
  });

  // Get Cash Order Details
  this.get('cards-api/v1/ampolcash/:grandParentId/:accountNumber/orders/:orderNumber', () => cashOrderDetails);

  // Get Cash Order Defaults
  this.get('cards-api/v1/ampolcash/:grandParentId/:accountNumber/orders/defaults', (schema, request) => {
    const { accountNumber } = request.params;

    return accountNumber === '0500001405' ? cashOrderDefaultsLoadable : cashOrderDefaultsPreloaded;
  });

  // Create Cash Order
  this.post('cards-api/v1/ampolcash/:grandParentId/:accountNumber/orders', () => cashOrderCreateResponse);

  // Activate all Cash Order cards
  this.post('cards-api/v1/ampolcash/:grandParentId/:contractId/order/:orderNumber/activate', () => {});

  // Get Cash Card Details
  this.get('cards-api/v1/ampolcash/:grandParentId/:accountNumber/orders/:orderNumber/cards/:cardNumber', () => cashOrderCardDetails);
}
